__turbopack_context__.v({
  "className": "dmmono_f4a96c4a-module__mAnoCa__className",
  "variable": "dmmono_f4a96c4a-module__mAnoCa__variable",
});
